import React from "react";
import CollectionItem from "../components/MyCollection/CollectionItem";

export default function CollectionItemPage() {
  return <CollectionItem />;
}
